import { Component } from '@angular/core';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.scss',
  standalone: false,
})
export class AdministrationComponent {
  public isLoading = false;
}
